"use client";

import React from "react";
import Link from "next/link";
import { Button } from "@heroui/button";
import { useRouter, usePathname } from "next/navigation";
import { useSession } from "next-auth/react";

export default function CompanySummaryCard({
  post,
  session: initialSession,
  availableDate,
  dateNow,
}) {
  const { data: session, status } = useSession();
  const router = useRouter();
  const pathname = usePathname();
  const isSession = status === "authenticated";

  const { investment_strategy, financials } = post || {};

  if (!post) {
    return <div>Loading...</div>;
  }

  const getTextColor = (strategy) => {
    switch (strategy) {
      case "Buy":
        return "text-green-500";
      case "Hold":
        return "text-orange-500";
      case "Sell":
        return "text-red-500";
      default:
        return "text-gray-500";
    }
  };

  const getBackgroundColor = (strategy) => {
    switch (strategy) {
      case "Buy":
        return "bg-green-600";
      case "Hold":
        return "bg-orange-500";
      case "Sell":
        return "bg-red-500";
      default:
        return "bg-gray-200";
    }
  };
  const formatAttributeName = (name) => {
    if (name === "pb") {
      return "P/B";
    } else if (name === "pe_foward") {
      return "P/E (forward)";
    } else if (name === "marketcap") {
      return "Market Cap. (M)";
    } else if (name === "share_os") {
      return "Shares O/S (M)";
    } else if (name === "current_yield") {
      return "Current Yield (%)";
    } else if (name === "week_range") {
      return "52 Week Range";
    } else {
      return name
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
  };

  const strategyTextColor = getTextColor(investment_strategy);
  const strategyBackgroundColor = getBackgroundColor(investment_strategy);

  const chipStyle = `inline-block px-3 py-1 w-16 text-center text-white font-bold rounded-full ${strategyBackgroundColor}`;

  const getRowBackgroundColor = (index) => {
    return index % 2 === 0 ? "bg-white" : "bg-gray-100";
  };

  const handleSignInClick = () => {
    console.log("Sign In button clicked");
    if (status === "unauthenticated") {
      sessionStorage.setItem("fromBanner", "true");
      sessionStorage.setItem("redirectPath", pathname);
      router.push("/sign-in");
    } else {
      router.push("/account");
    }
  };

  return (
    <div className="w-full">
      <div className="text-lg sm:text-xl md:text-2xl lg:text-2xl font-bold mb-4">
        Rating and Key Data
      </div>

      {isSession ? (
        <span className={chipStyle}>{investment_strategy || "N/A"}</span>
      ) : (
        <span className=""></span>
      )}

      <div
        className={`${
          isSession ? "overflow-hidden border rounded-xl mt-4" : "blur-sm mt-4"
        }`}
      >
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-200">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Metrics
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(financials).map(([attribute, value], index) => (
              <tr key={attribute} className={getRowBackgroundColor(index)}>
                <td className="px-6 w-60 py-2 text-sm whitespace-nowrap">
                  {formatAttributeName(attribute)}
                </td>
                <td className="text-sm w-full text-center whitespace-nowrap">
                  {value || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Call to Action for Non-Subscribers */}
      {!isSession && (
        <div className="hidden sm:block mt-4 p-4  flex-col items-center justify-center border rounded-2xl bg-1A2C45 text-center">
          <div className="flex  items-center justify-center space-x-5">
            <p className="text-E6E6E6 pt-4  font-light text-sm">
              Already a subscriber?
            </p>
            <Button
              className="bg-E6E6E6 text-black"
              onPress={handleSignInClick}
              size="sm"
            >
              Sign In
            </Button>
          </div>
          <h3 className="text-lg font-semibold text-white">
            Want to know the fair value of the stock?
          </h3>
          <p className="text-sm text-white mb-4">
            Subscribe for free to get exclusive insights and data.
          </p>
          <Button
            onPress={() => router.push("/sign-up")}
            className="px-6 py-2 bg-1B51CA  text-white "
          >
            Subscribe Now
          </Button>
        </div>
      )}
    </div>
  );
}
